module.exports = __webpack_public_path__ + "static/img/voice_assistant.97d930a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/air_2020/voice_assistant.png
// module id = G7tm
// module chunks = 1